import React from 'react';
import { Box, Button } from '@mui/material';
import { styled } from '@mui/material/styles';
import LastEdited from '../lastEdited';
import { useApplication, useUpdateApplication } from '.';

const SpacedButton = styled(Button)(({ theme }) => ({
	marginTop: theme.spacing(2.5), // 20px
}));

const ErrorBox = styled(Box)({
	color: '#e74c3c',
	fontWeight: 'bold',
});

// Do not optimize. This depends on `application`
const ApplicationControls = () => {
	const { application, privileges, serverMessage, isDirty } =
		useApplication();
	const { saveApplication } = useUpdateApplication();

	return (
		<>
			{serverMessage && (
				<ErrorBox>
					{serverMessage}
				</ErrorBox>
			)}
			{privileges.editCourses &&
			application.applicationRows.length > 0 ? (
				<SpacedButton
					onClick={() => saveApplication()}
					variant="contained"
					color="primary"
					disabled={
						(application.schoolId !== undefined &&
							application?.schoolId < 1) ||
						!isDirty
					}
				>
					Save
				</SpacedButton>
			) : null}
			<LastEdited data={application} />
		</>
	);
};

export default ApplicationControls;
